import {Directive, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Utilities} from '../../utilities/utilities.model';

@Directive({
	selector: '[amdInfiniteScroller]'
})
export class InfiniteScrollerDirective implements OnInit {

	@Input() scrollPercent = 70;
	@Input() offSet = 0;
	@Output() loadMore: EventEmitter<void> = new EventEmitter<void>();

	position = {
		sT: 0,
		sH: 0,
		cH: 0
	};

	constructor() {
	}

	ngOnInit() {
		document.addEventListener('scroll', (event: any) => {
			if (!Utilities.isVoid(event) && !Utilities.isVoid(event.target)) {
				this.position.sT = event.target.scrollTop;
				this.position.sH = event.target.scrollHeight;
				this.position.cH = event.target.clientHeight;
				if (this.isScrollExpectedPercent()) {
					this.loadMore.emit();
				}
			}
		}, true);
	}

	private isScrollExpectedPercent() {
		return ((this.position.sT + this.position.cH - this.offSet) / this.position.sH) > (this.scrollPercent / 100);
	}
}
